
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { initClient } from '../../../api';
import { ActionsApiUiClient, ActionDefinition } from '../../backend/backendapi';
import ActionDefinitionStore from '../../../stores/ActionDefinitionStore';

@Component
export default class ActionDeleteModal extends Vue {
  private readonly api = initClient(ActionsApiUiClient);
  private readonly store = new ActionDefinitionStore();
  
  actions: ActionDefinition[] = [];

  public open(actions: ActionDefinition[]): void {
    this.actions = actions;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async deleteSelected(): Promise<void> {
    if (!this.actions.length) {
      return;
    }
    let deleted = 0;
    for (let action of this.actions) {
      try {
        await this.api.delete(action.id);
        this.store.forgetDefinition(action);
      } catch (e) {
        this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e));
      }
    }
    if (deleted > 0) {
      this.$toasted.info(this.$t('txtDeleted').toString());
    }
    this.$emit('deleted');
    this.dismiss();
  }
}
